<template>
  <div class="list-item-rapport" @click="onClickRow">
    <v-chip class="chip mr-2" label pill small :color="colors[article_status]">
      {{ article_status }}
    </v-chip>

    <div class="report-title">
      <div class="report-title">
        <v-tooltip top dark>
          <template v-slot:activator="{ on, attrs }">
            <span class="clickable" v-bind="attrs" v-on="on"> {{ article_title }}</span>
          </template>
          <span>{{ article_title }}</span>
        </v-tooltip>
      </div>
      <TagsRow :tags="tags" />
    </div>
    <div class="report-date">
       <v-tooltip top dark>
          <template v-slot:activator="{ on, attrs }">
            <span class="clickable" v-bind="attrs" v-on="on"> {{ publisher }}</span>
          </template>
          <span>{{ publisher }}</span>
        </v-tooltip>
      </div>
    <div class="report-date">{{ article_year }}</div>
    <div class="report-date">{{ createdDate }}</div>
    <div class="report-date">{{ updatedDate }}</div>
    <div class="report-date">{{ updated_by }}</div>
  </div>
</template>

<script>
import { dateParseJustDate as dateParse } from '../../lib/misc'
import { colors } from '@/assets/data/colors'
import TagsRow from '@/components/shared/TagsRow.vue'

export default {
  name: 'LatestReportsListItem',
  props: {
    id: { type: Number },
    article_status: { type: String },
    article_title: { type: String },
    created_at: { type: String },
    updated_at: { type: String },
    updated_by: { type: String },
    tags: { type: Array },
    article_year: { type: String },
    article_name: { type: String },
  },
  components: {
    TagsRow,
  },
  data() {
    return {
      colors,
    }
  },
  computed: {
    createdDate() {
      return dateParse(this.created_at)
    },
    updatedDate() {
      return dateParse(this.updated_at)
    },
    section() {
      return this.$route.params.section
    },
    publisher() {
      return this.article_name
    },
   
  },
  methods: {
    onClickRow() {
      this.$router.push({ name: 'SingleReport', params: { section: this.section, id: this.id } })
    },
  },
}
</script>

<style lang="less" scoped>
.list-item-rapport {
  display: grid;
  grid-template-columns: 75px 1fr 200px 50px 100px 100px 140px;
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 0px;

  padding: 6px 10px;
  border-bottom: #ccc 1px solid;
  background-color: #fff;
  cursor: pointer;
  &:hover {
    background-color: rgb(245, 245, 245);
  }
  .chip {
    display: flex;
    justify-content: center;
  }
  .report-title {
    display: inline-flex;
    gap:5px;
    flex-wrap: wrap;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
  }
  .report-date {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .clickable {
    cursor: pointer;
  }
}
</style>
